import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { CompanyAssessmentListItemResponse } from '../../../models/company-assessment-list-item-response.model';

export const CreateAssessmentDialogStoreActions = createActionGroup({
  source: 'CreateAssessmentDialogStore',
  events: {
    'Create Company Assessment Request': emptyProps(),
    'Create Company Assessment Success': props<{ companyAssessment: CompanyAssessmentListItemResponse }>(),
  },
});
